var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentDownloadOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0306 15.9092L17.1808 15.0594L15.6266 16.6136V11.7021H14.4246V16.6136L12.8703 15.0594L12.0205 15.9092L15.0256 18.9143L18.0306 15.9092Z",
    fill: "#4C39A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8186 17.7125H4.80847V3.28817H9.61658V6.89425C9.61753 7.21275 9.74447 7.51794 9.96969 7.74316C10.1949 7.96838 10.5001 8.09532 10.8186 8.09627H14.4247V9.89931H15.6267V6.89425C15.6288 6.81526 15.6138 6.73675 15.5827 6.66412C15.5516 6.5915 15.5051 6.52648 15.4464 6.47354L11.2393 2.26645C11.1864 2.20775 11.1214 2.16124 11.0488 2.13011C10.9761 2.09898 10.8976 2.08398 10.8186 2.08614H4.80847C4.48997 2.08709 4.18478 2.21404 3.95956 2.43926C3.73434 2.66448 3.6074 2.96966 3.60645 3.28817V17.7125C3.6074 18.031 3.73434 18.3362 3.95956 18.5614C4.18478 18.7866 4.48997 18.9136 4.80847 18.9145H10.8186V17.7125ZM10.8186 3.52857L14.1843 6.89425H10.8186V3.52857Z",
    fill: "#4C39A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownloadOutline);
export default __webpack_public_path__ + "static/media/documentDownloadOutline.a291d021.svg";
export { ForwardRef as ReactComponent };